
import { i18nText } from '@/locales';
import Vue from "vue";
import Component from "vue-class-component";
import { LoyaltyCertStore } from "@/store/modules/LoyaltyCert";
import { LoyaltySubscriptionStore } from "@/store/modules/Loyalty/Subscription/LoyaltySubscription";
import { formRules, VisitPayFormData } from "@/form/visits/Pay/Visit";
import { RecordDataForm } from "@/form/visits/New/Record";
import { ITableColumn } from "@/entity/table/table.types";
import { ClientsStore } from "@/store/modules/Clients";

@Component
export class PayMix extends Vue {
    formVisit = new VisitPayFormData();
    form = new RecordDataForm();
    visit_id: number = 0;
    client_id: number = 0;

    Rules = formRules;
    showPayModal = false;
    confirmLoading = false;
    visibleCashCashboxes = false;
    visibleCardCashboxes = false;
    showSearchLoyaltyBlock = true;
    maskedPhone = "";
    boxData: any[] = [];
    notification_cert = "";
    notification_subs = "";

    paymentMethods: any = {
        certificates: [],
        memberships: [],
    };

    get columns(): ITableColumn[] {
        return [
            {
                title: i18nText("Позиция"),
                dataIndex: "",
                key: "name",
                width: "80%",
                scopedSlots: {
                    customRender: "name",
                },
            },
            {
                title: i18nText("Сумма, ₽"),
                dataIndex: "total",
                key: "total",
                scopedSlots: {
                    customRender: "total",
                },
            },
        ];
    }


    get Certificates():any[] {
        const items = LoyaltyCertStore.loyaltyCerts?.data;
        if (items) {
             items.map((item:any)=>{
                item['template']='certificate'
            })
            return items
        } else {
            return [];
        }
    }

    get Subscriptions():any[] {
        const items = LoyaltySubscriptionStore.loyaltySubscriptions?.data;
        if (items) {
             items.map((item:any)=>{
                item['template']='subscription'
            })
            return items
        } else {
            return [];
        }
    }

    get ClientsAcc():any[] {
        const items = ClientsStore.clients?.data
        if (items) {
            items.map((item:any)=>{
                item['template']='personal_account'
            })
            return items
        } else {
            return [];
        }
    }

}
